
import { defineComponent } from '@nuxtjs/composition-api'
import ConstructorLayout from '~/components/Constructor/ConstructorLayout'
import CardAuthor from '~/components/Card/CardAuthor/CardAuthor'

export default defineComponent({
  name: 'academy_magazine_detail',
  layout: 'academy_default',
  components: { CardAuthor, ConstructorLayout },
  async asyncData({ app, redirect, route }) {
    const { data } = await app.$api.getAcademyArticleBySlug(route.params.slug)
    const magazine = await app.$api.getAcademyMagazine()
    if (!data || !data.data || !data.data.length) {
      redirect('/')
    }

    return {
      page: data?.data[0]?.attributes,
      magazine: magazine.data?.data?.attributes,
      author: data?.data[0]?.attributes?.author?.data?.attributes,
      api: process.env.apiUrl,
    }
  },
  head() {
    return this.$seo.generate(
      this.page?.serp,
      this.page?.social_sharing,
      this.page?.article_title
    )
  },
  computed: {
    coverImage() {
      if (!this.page || !this.page.cover_image || !this.page.cover_image.data) {
        return null
      }
      return `${this.page.cover_image.data.attributes.url}`
    },
  },
  methods: {
    scrollScreen() {
      const header = document.querySelector('.details-page__header')
      const headerHeight = header.offsetHeight
      if (!header && !headerHeight) {
        return
      }
      window.scrollTo({
        top: headerHeight,
        behavior: 'smooth',
      })
    },
  },
})
